

app.controller('RegisterCtrl', function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter, $translate) {
    $scope.user = {
        Email: '',
        Password: '',
        Handphone: '',
        Sales: '',
        RegistrationInfo: '',
        RegistrationInfoSosmed: '',
        RegistrationInfoOthers: ''
    };

    $scope.showSales = false;
    $scope.disableSales = false;



    $scope.user.PhoneCode = '+62';
    $scope.disclaimerRek = false;
    $scope.SalesSelected = '';
    $scope.ListSales = [];

    $scope.page = 'registration';

    $scope.selectSales = function (item, model, label, event) {
        if (item.SalesPersonNID) {
            $scope.user.Sales = item.SalesPersonNID;
            $scope.SalesSelected = item;
        }

    };

    $scope.salesChange = function () {
        //console.log('sales2', $scope.user.Sales);
    }

    var allPromise = $q.all([
         $http({
             method: 'GET',
             url: '/service/client.svc/GetCountryPhone',
             cache: true,
         }).then(function (data) {
             $scope.ListCountryPhone = data.data.d;
         }, function (error) { }),

         $http({
             method: 'GET',
             url: '/service/client.svc/GetCIFSales',
             cache: true,
         }).then(function (data) {
             $scope.ListSales = data.data.d;
             console.log('listSales', $scope.ListSales);

             if ($scope.ListSales != null)
                 $scope.user.Sales = $scope.ListSales[0];

         }, function (error) { }),
    ]);

    $scope.showAgreement = function (number) {
        let htmlName = 'template/BCAagereement' + number + '.html';
        var modalInstance = $uibModal
        .open({
            animation: true,
            templateUrl: htmlName,
            controller: 'BCAAgreementCtrl',
            size: 'lg',
            backdrop: 'static',
            resolve: {
                agreementNumber: function () {
                    return number;
                }
            }
        });
        modalInstance.result.then(function (response, agree) {
            if (response == 'accept') {
                if (number == 1) {
                    $scope.agree1 = true;
                    $scope.disclaimerREGISTER = true;
                }

                //if (number == 3)
                //{
                //    $scope.agree3 = true;
                //    $scope.disclaimerPTMKES = true;
                //}


            }
        }, function () { });
    };

    $scope.validateAgreementREGISTER = function () {
            if (!$scope.agree1) {
                $scope.disclaimerREGISTER = false;
                swal('Error', 'Mohon klik PERNYATAAN KEBIJAKAN PRIVASI Trust Online System.', 'error');
            }
    }

    $scope.showAgreement = function (number) {
        let htmlName = 'template/Registeragereement' + number + '.html';
        var modalInstance = $uibModal
        .open({
            animation: true,
            templateUrl: htmlName,
            controller: 'RegisterAgreementCtrl',
            size: 'lg',
            backdrop: 'static',
            resolve: {
                agreementNumber: function () {
                    return number;
                }
            }
        });
        modalInstance.result.then(function (response, agree) {
            if (response == 'accept') {
                if (number == 1) {
                    $scope.agree1 = true;
                    $scope.disclaimerREGISTER = true;
                }


            }
        }, function () { });
    };


    $scope.prepareData = function () {

        //if ($scope.user.AccountType)
        //    $scope.user.AccountType = Number($scope.user.AccountType);

        //if ($scope.user.RegistrationInfo)
        //    $scope.user.RegistrationInfo = Number($scope.user.RegistrationInfo);

        //if ($scope.user.RegistrationInfoSosmed)
        //    $scope.user.RegistrationInfoSosmed = Number($scope.user.RegistrationInfoSosmed);
        //else
        //    $scope.user.RegistrationInfoSosmed = 0;

        if ($scope.user.Sales)
            $scope.user.Sales = $scope.user.Sales.SalesPersonID;

    }

    //validation popup
    $scope.showModal = false;
    $scope.captchaValid = false;

    $scope.closeModal = function () {
        $scope.showModal = false;
    }

    window.onCaptchaSuccess = function (response) {
        $scope.$apply(function () {
            $scope.captchaValid = true;
            $scope.captchaResponse = response;
        });
    };
    //end validation popup

    $scope.submit = function (form) {
        $scope.prepareData();

        //validation popup
        $scope.errorMessages = [];

        angular.forEach(form, function (field, fieldName) {

            if (fieldName.startsWith('$')) return;

            if (field.$error && field.$error.required) {

                let label = field.$name.toUpperCase();

                $scope.errorMessages.push(label + ' wajib diisi');
            }
        });

        if (!$scope.captchaValid) {
            $scope.errorMessages.push('Captcha wajib diisi');
        }

        if ($scope.user.ConfirmPassword != $scope.user.Password) {
            $scope.errorMessages.push('Password belum sesuai');
        }

        if ($scope.errorMessages.length > 0) {
            $scope.showModal = true;
            return;
        }
        //validation end

        //captcha
        var challenge = grecaptcha.getResponse();
        if (!challenge) {
            alert("Mohon ulangi centang captcha");
            return false;
        }

        $translate('VALIDATE.confirmation').then(function (strText) {
            $rootScope.AlertYesNo('question', 'Konfirmasi', strText)
            .then((result) => {
                if (result.value) {
                    $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                    $http({
                        method: 'POST',
                        url: '/service/client.svc/RegistrasiUser',
                        data: {
                            User: $scope.user
                        }
                    }).then(function (data) {
                        console.log('res', data);

                        if (data.data.d.result) {
                            swal('Registration Success', data.data.d.message, 'success').then(function () {
                                $window.location.href = "#/login/";
                                $window.location.reload();
                            });
                        }
                        else {
                            swal('Failed', data.data.d.message, 'info');
                        }
                    }, function (error) { });
                }
            });
        });
    }

    

    

    allPromise.then(function () {
        if ($routeParams.id) {
            //console.log('param', $routeParams.id);

            var sales = $filter('filter')($scope.ListSales, { SalesPersonID: $routeParams.id }, true)[0];
            console.log('sales', sales);

            $scope.user.Sales = sales;
            $scope.user.RegistrationInfo = '1';
            $scope.showSales = true;
            $scope.disableSales = true;
        }
        else {
            $scope.showSales = false;
            $scope.disableSales = false;
        }

    });


});







app.controller('ActivationCtrl', function ($scope, $routeParams, $rootScope, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $translate) {
    $scope.user = {
        Email: '',
        OTP: '',
    };

    $scope.printXyz = function () {
        console.log($scope.user);
        console.log('CODE', $scope.user.code1);
        console.log('EMAIL', $scope.user.Email);
    }

    if ($routeParams.generatedkey) {
        $scope.user.generatedkey = $routeParams.generatedkey;
    }
    else {
        $window.location.href = "#/register";
        $window.location.reload();
    }

    $scope.page = 'activation';

    var allPromise = $q.all([

    ]);


    $scope.submit = function () {
        $scope.user.OTP = $scope.user.code1 + $scope.user.code2 + $scope.user.code3 + $scope.user.code4;
        console.log('user', $scope.user);
        $translate('VALIDATE.confirmation').then(function (strText) {
            $rootScope.AlertYesNo('question', 'Konfirmasi', strText)
            .then((result) => {
                if (result.value) {
                    $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                    $http({
                        method: 'POST',
                        url: '/service/client.svc/AktivasiUser',
                        data: {
                            User: $scope.user
                        }
                    }).then(function (data) {

                        if (data.data.d.result) {
                            swal('Activation Success', data.data.d.message, 'success').then(function () {
                                $window.location.href = "#/login";
                                $window.location.reload();
                            });
                        }
                        else {
                            swal('Failed, Check OTP in Email', data.data.d.message, 'info');
                        }
                    }, function (error) { });
                }
            });
        });
    }


    allPromise.then(function () {
        $http({
            method: 'GET',
            url: '/service/client.svc/recheckActivationLink?key=' + window.location.href.substr(window.location.href.lastIndexOf('/') + 1),
        }).then(function (data) {
            if (data.data.d.result) {
            }
            else {
                swal('Failed', data.data.d.message, 'info');
                $window.location.href = "#/login";
            }
        }, function (error) { })

    });


    $scope.verif = function (index, event) {
        if ($scope.code1 && $scope.code2 && $scope.code3 && $scope.code4)
            console.log('done1')
        else {
            if (index && ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105))) {
                let focusCtrl = "#verif" + (index + 1);
                angular.element(focusCtrl).focus();
            }
        }
    }

    $scope.processCb = function (event) {
        let data = event.originalEvent.clipboardData.getData('text/plain');
        if (data.length == 4) {
            $scope.code1 = data[0];
            $scope.code2 = data[1];
            $scope.code3 = data[2];
            $scope.code4 = data[3];
        }
    }

    $scope.verFocus = function (index) {
        if ($scope.code1 && $scope.code2 && $scope.code3 && $scope.code4)
            console.log('done2')
        else {
            switch (index) {
                case 1: $scope.code1 = ''; break;
                case 2: $scope.code2 = ''; break;
                case 3: $scope.code3 = ''; break;
                case 4: $scope.code4 = ''; break;
            }
        }
    }
});
